package gr.tech.GRAttestation.models.storeusers

enum class STORE_USER_INVITE_STATUS(val bit: Short, val status: String) {
    CANCELLED(0, "CANCELLED"),
    PENDING(1, "PENDING"),
    ACCEPTED(2, "ACCEPTED");

    companion object {
        fun parseStatus(status: String): STORE_USER_INVITE_STATUS {
            return when (status.lowercase()) {
                "cancelled" -> CANCELLED
                "pending"   -> PENDING
                "accepted"  -> ACCEPTED
                else        -> PENDING
            }
        }

        fun parseStatus(status: Short): STORE_USER_INVITE_STATUS {
            return when (status) {
                0.toShort() -> CANCELLED
                1.toShort() -> PENDING
                2.toShort() -> ACCEPTED
                else        -> PENDING
            }
        }
    }
}
